import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, BooleanColumn, TextColumn} from '../../../../shared/Models/columns';
import * as moment from 'moment';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BackOfficeInvoiceService} from '../../../Services/invoice.service';
import {DealersService} from '../../../Services/dealers.service';
import {SupplierService} from '../../../Services/supplier.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {Invoice} from '../../../Models/Invoice';
import {CreditInvoiceService} from '../../../Services/creditInvoice.service';
import {Helper} from '../../../../helpers/helper.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import {CreditInvoiceItem} from '../../../Models/CreditInvoiceItem';
import {IButton} from '../../../../shared/card/card.component';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';


@Component({
  selector: 'app-backoffice-invoice-overview',
  templateUrl: './backoffice-invoice-overview.component.html',
  styleUrls: ['./backoffice-invoice-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class BackofficeInvoiceOverviewComponent implements OnInit {
  public invoiceId: number;
  public isPartialPaid = false;
  public isEditPartialPaid = false;
  public partialPaid: string;
  public invoice = new Invoice();
  public grid: Grid;
  public isEdit = false;
  public creditInvoiceItems: CreditInvoiceItem[];
  public headerButtons;
  public specialButtons: IButton[] = [];
  public params;
  public templates;
  public disableCreditInvoiceBtn = false;
  selectedTemplate;
  public dateFormat;
  @ViewChild('amountPriceTemp', {static: true}) amountPriceTemp;
  @ViewChild('amountExPriceTemp', {static: true}) amountExPriceTemp;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('partialPaidModal', {static: false}) partialPaidModal = null;
  @ViewChild('creditInvoiceModal', {static: false}) creditInvoiceModal = null;
  @ViewChild('createCustomInvoiceModal', {static: false}) createCustomInvoiceModal = null;
  @ViewChild('statusTemplate', {static: true}) statusTemplate;
  @ViewChild('typeTemplate', {static: true}) typeTemplate;
  @ViewChild('dueDateTemplate', {static: true}) dueDateTemplate;
  @ViewChild('addCreditInvoiceForm', {static: false}) addCreditInvoiceForm;
  @ViewChild('addCreateCustomInvoiceForm', {static: false}) addCreateCustomInvoiceForm;

  constructor(
    private invoiceService: BackOfficeInvoiceService,
    private router: Router,
    private translator: TranslateService,
    private dealersService: DealersService,
    private broadcastService: BroadcastService,
    private helper: Helper,
    private auth: AuthenticationService,
    private invoiceLayoutService: InvoiceLayoutService) {
  }

  ngOnInit() {
    this.headerButtons = [
      {
        name: this.translator.instant('admin.order.custom_invoice.button_title'),
        btnIcon: 'fa fa-plus',
        method: 'openGenerateInvoiceModal',
        customClass: 'btn btn-grey btn-outline-primary ripple light'
      },
      {
        name: this.translator.instant('admin.order.export'),
        btnIcon: 'feather icon-download',
        method: 'exportInvoices',
        customClass: 'btn-primary'
      },
    ];
    this.headerButtons.forEach(items => {
      this.specialButtons.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });

    this.dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <BooleanColumn>{
          type: BooleanColumn.type,
          sortable: false,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.date',
          prop: 'created',
          sortable: true,
          type: TextColumn.type,
          minWidth: 100,
          maxWidth: 140,
          translate: true,
          valueFormatter: row => moment(row).format(this.dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.number',
          prop: 'id',
          sortable: true,
          type: TextColumn.type,
          minWidth: 135,
          maxWidth: 140,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.invoice_dealer',
          prop: 'invoiceDealer',
          sortable: true,
          type: TextColumn.type,
          width: 250,
          maxWidth: 500,
          translate: true,
          valueFormatter: row => row.companyName
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.due_date',
          prop: 'dueDate',
          sortable: true,
          type: TextColumn.type,
          minWidth: 230,
          translate: true,
          valueTemplate: this.dueDateTemplate,
          valueFormatter: row => {
            if (!row) {
              return '-';
            }
            return moment(row).format(this.dateFormat);
          },
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.amount_inc',
          prop: 'amount',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
          valueTemplate: this.amountPriceTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.amount_ex',
          prop: 'amountEx',
          sortable: false,
          type: TextColumn.type,
          minWidth: 110,
          maxWidth: 140,
          translate: true,
          valueTemplate: this.amountExPriceTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          width: 200,
          maxWidth: 300,
          translate: true,
          valueTemplate: this.statusTemplate
        },
        <TextColumn>{
          name: 'doctrine.invoice.type',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          width: 200,
          maxWidth: 300,
          translate: true,
          valueTemplate: this.typeTemplate
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-download fa-lg',
              tooltip: 'global.download',
              onclick: (row) => {
                this.invoiceService.getPdf(row.id).subscribe((resp) => {
                    if (resp && typeof resp === 'object') {
                      this.helper.createDownloadLink(resp.url, resp.filename);
                    }
                });
              },
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-pie-chart fa-lg',
              tooltip: 'global.partial_paid',
              onclick: row => {
                this.invoiceId = row.id;
                if (row.partialPaid !== null) {
                  this.partialPaid = JSON.parse(JSON.stringify(row.partialPaid));
                  this.isPartialPaid = true;
                  this.isEditPartialPaid = true;
                } else {
                  this.partialPaid = null;
                  this.isPartialPaid = false;
                  this.isEditPartialPaid = false;
                }
                this.partialPaidModal.show();
              },
              showCallback: row => {
                if (row.isCredit === false) {
                  return row;
                }
              },
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-credit-card fa-lg',
              tooltip: 'global.credit_invoice',
              onclick: (row) => {
                this.openCreditInvoiceModal(row);
              },
              showCallback: row => {
                if (row.isCredit === false) {
                  const totalCredited = row.creditInvoices
                    ? row.creditInvoices.reduce((sum, ci) => sum + (Number(ci.amountEx) || 0), 0)
                    : 0;
                  if (totalCredited < (Number(row.amountEx) || 0)) {
                    return row;
                  }
                }
              },
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.invoiceService,
      rememberURL: this.router.url,
      method: 'getInvoices',
      root: 'invoice',
      defaultSort: 'created',
      bulkActionMethod: 'invoiceBulkAction',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      multipleRowSearch: true,
      showIsCreditCheckbox: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          hasInvoiceStatus: true,
          label: 'doctrine.attributes.model',
          type: 'ng-select',
          hasBackofficeDropdownListFilter: true,
          hasNormalSearch: true,
          order: [
            {actionOrder: 1, datepickerOrder: 2, statusOrder: 4, normalSearchOrder: 3}
          ],
          searchArrays: [
            {
              index: 3,
              value: new ServiceSearchItem(this.dealersService, 'getAllDealers', {sortType: 'ASC', sortBy: 'companyName'}, (res) => {
                const options = [];
                options.push({value: 'all', label: this.translator.instant('global.all')});

                for (const row of res.data) {
                  options.push({value: row.id, label: row.companyName});
                }
                return options;
              }),
              name: 'dealer_id',
              label: 'doctrine.attributes.dealer',
            }
          ],
        }
      ],
    };

    this.invoiceLayoutService.getActiveLayoutList(true).subscribe(res => {
      this.templates = [];
      res.data.map(template => {
        this.templates.push({
          label: template.name,
          value: template.id,
        });
      });
      this.selectedTemplate = this.templates[0] ? this.templates[0].value : null;
    });

  }

  editPartialPaid() {
    if (this.isEditPartialPaid && !this.isPartialPaid) {
      this.invoice.partialPaid = null;
      this.invoice.status = Invoice.INVOICE_OPEN.key;
    } else {
      this.invoice.partialPaid = this.partialPaid;
      this.invoice.status = Invoice.INVOICE_PARTIAL_PAID.key;
    }
    delete this.invoice.creditInvoiceItems;
    this.invoiceService.updateInvoice(this.invoice, this.invoiceId).subscribe(() => {
      this.partialPaidModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getInvoices');
    });
  }

  openCreditInvoiceModal(invoice) {
    this.invoice = invoice;
    this.isEdit = false;
    this.creditInvoiceItems = [];
    this.addCreditItem();
    this.creditInvoiceModal.show();
    this.invoiceId = invoice.id;
  }

  get totalCreditedAmount(): number {
    if (!this.invoice || !this.invoice.creditInvoices) {
      return 0;
    }
    return this.invoice.creditInvoices.reduce((sum, ci) => sum + (Number(ci.amountEx) || 0), 0);
  }

  get currentCreditAmount(): number {
    if (!this.creditInvoiceItems) {
      return 0;
    }
    return this.creditInvoiceItems.reduce((sum, item) => sum + ((Number(item.amount) || 0) * (Number(item.price) || 0)), 0);
  }

  get remainingAmount(): number {
    if (!this.invoice) {
      return 0;
    }
    return (Number(this.invoice.amountEx) || 0) - this.totalCreditedAmount;
  }

  addCreditItem() {
    this.creditInvoiceItems.push(new CreditInvoiceItem());
  }

  removeCreditItem(creditInvoiceItemIndex) {
    this.creditInvoiceItems.splice(creditInvoiceItemIndex, 1);
    this.creditInvoiceItems = JSON.parse(JSON.stringify(this.creditInvoiceItems));
  }

  onCredit() {
    this.disableCreditInvoiceBtn = true;
    const creditInvoice = new Invoice();
    creditInvoice.creditInvoiceItems = this.creditInvoiceItems;
    creditInvoice.invoiceLayout = this.selectedTemplate;
    delete creditInvoice.creditInvoices;
    this.invoiceService.creditInvoice(creditInvoice, this.invoiceId, this.isEdit).subscribe(() => {
      this.disableCreditInvoiceBtn = false;
      this.creditInvoiceModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getInvoices');
      let message = 'admin.order.backoffice.invoice.draft_overview.credit_success';
      if (this.isEdit) {
        message = 'admin.backoffice.invoice.overview.credit_update_success';
      }

      this.helper.popMessageDialog(
        this.translator.instant('global.success_message.title'),
        this.translator.instant(message),
        'success',
        false
      );
    });
  }

  hideModal() {
    this.creditInvoiceModal.hide();
  }


  calculateOverdueDays(date) {
    let now = moment();
    now = moment(now, 'YYYY/MM/DD');
    const dueDate = moment(date, 'YYYY/MM/DD');
    return now.diff(dueDate, 'days');
  }

  exportInvoices() {
    this.invoiceService.exportInvoices(this.params).subscribe(res => {

    });
  }

  setParams(event) {
    this.params = event;
  }

  callFunction(method) {
    this[method]();
  }

  openGenerateInvoiceModal() {
    this.createCustomInvoiceModal.showDialog();
  }

  onInvoiceGenerated(event) {
    if (event) {
      this.broadcastService.broadcast('refreshGrid', 'getInvoices');
    }
  }

  formatDateString(date) {
    return moment(date).format(this.dateFormat);
  }
}
